var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 41,
    viewBox: "0 0 38 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 32.5H10V36.5H34V4.5H10V8.5H6V2.5C6 1.4 6.9 0.5 8 0.5H36C37.1 0.5 38 1.4 38 2.5V38.5C38 39.6 37.1 40.5 36 40.5H8C6.9 40.5 6 39.6 6 38.5V32.5ZM10 18.5H24V22.5H10V28.5L0 20.5L10 12.5V18.5Z",
    fill: "#20262D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.73e7588bde8a35190798cf5737fbf217.svg";
export { ForwardRef as ReactComponent };